import { createFileRoute, Link, LinkProps } from "@tanstack/react-router";
import { BotIcon, CpuIcon, GitCompareArrowsIcon } from "lucide-react";

import { H1 } from "@/components/ui/typography";

export const Route = createFileRoute("/app/_sidebar-layout/create/choice")({
  component: RouteComponent,
  head: () => ({ meta: [{ title: "Create Feed" }] }),
});

function ChoiceCard({
  title,
  description,
  icon,
  ...props
}: LinkProps & {
  title: string;
  description: string;
  icon: React.ReactNode;
}) {
  return (
    <Link
      {...props}
      className="bg-slate-action px-6 py-4 rounded-lg flex items-center gap-6 text-left cursor-pointer-extra"
    >
      <span className="shrink-0">{icon}</span>
      <div className="flex flex-col gap-1">
        <span className="text-lg md:text-xl font-semibold">{title}</span>
        <span className="text-slate-dim md:text-lg">{description}</span>
      </div>
    </Link>
  );
}

function RouteComponent() {
  // Publish the feed

  return (
    <div className="flex flex-col items-center justify-center min-h-full gap-8 mx-auto px-10 py-20 overflow-y-auto">
      <H1>Choose starting point</H1>
      <div className="flex flex-col gap-4 mx-auto max-w-2xl">
        {/* <ChoiceCard
          title="Simple Feed"
          description="Start with a simple feed and build from there. Can escape to the full editor when ready."
          icon={<BabyIcon className="h-6 w-6" />}
          to="/app/create/simple"
        /> */}
        <ChoiceCard
          title="Editor"
          description="Use graze's full power to build your feed's logic."
          icon={<CpuIcon className="h-6 w-6" />}
          to="/app/create"
        />
        <ChoiceCard
          to="/app/create"
          search={{ generate: true }}
          title="Generate"
          description="Prompt an AI to generate a starting point for your feed."
          icon={<BotIcon className="h-6 w-6" />}
        />
        <ChoiceCard
          to="/app/migrate"
          title="Migrate"
          description="Move your existing feed into Graze. Feed retains likes and pins."
          icon={<GitCompareArrowsIcon className="h-6 w-6" />}
        />
      </div>
    </div>
  );
}
